import {Component, Inject, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {RebalanceService} from "@irb/irb-editors/rebalance/rebalance.service";
import {AppService} from "@irb/app.service";

@Component({ standalone: false,
  selector: 'irb-rebalance-type-info-dialog',
  templateUrl: './rebalance-type-info-dialog.component.html',
  styleUrls: ['./rebalance-type-info-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class RebalanceTypeInfoDialogComponent implements OnInit {
  expandedPanelId = '1';
  showTLH_FULL = true;
  ENABLE_TLH_FR = false;
  constructor(public dialogRef: MatDialogRef<RebalanceTypeInfoDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public mdd: any,
              private as: AppService) { }

  ngOnInit(): void {
    this.expandedPanelId = this.mdd?.rebalanceTypeObject?.value?.gvalue;
    this.showTLH_FULL = this.mdd?.isTLHSetInGlobal;
    this.ENABLE_TLH_FR = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.ENABLE_TLH_FR || false;

  }

  close() {
    this.dialogRef.close();
  }
}
